import { Check } from 'lucide-react';

const STEPS = ['Foundation', 'Power-ups', 'Brief', 'Ecosystem', 'Review'];

export default function StepProgress({ step, onJump }) {
  const pct = ((step + 1) / STEPS.length) * 100;
  const currentLabel = STEPS[step];

  return (
    <div data-testid="builder-progress" className="w-full">
      {/* Top row: current step label + counter */}
      <div className="flex items-center justify-between mb-2.5">
        <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400 font-semibold">
          <span className="w-1 h-1 rounded-full bg-[#00E5FF]" />
          {currentLabel}
        </span>
        <span className="text-[11px] font-mono text-slate-500 dark:text-slate-500">
          <span className="text-[#0A0A0A] dark:text-white font-bold">{step + 1}</span>
          <span className="mx-1">/</span>{STEPS.length}
        </span>
      </div>

      {/* Thin animated progress rail */}
      <div className="relative h-[3px] bg-slate-200 dark:bg-white/[0.08] rounded-full overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#00E5FF] via-[#00E5FF] to-violet-400 rounded-full transition-all duration-500 ease-out shadow-[0_0_12px_rgba(0,229,255,0.4)]"
          style={{ width: `${pct}%` }}
        />
      </div>

      {/* Tiny breadcrumb chips below for jump-back — extremely discreet */}
      <div className="flex items-center gap-1.5 mt-3 flex-wrap">
        {STEPS.map((label, i) => {
          const done = i < step;
          const active = i === step;
          const clickable = done;
          return (
            <button
              key={label}
              type="button"
              data-testid={`builder-step-${i}`}
              disabled={!clickable}
              onClick={() => clickable && onJump?.(i)}
              className={`group inline-flex items-center gap-1 text-[10px] font-medium tracking-wide transition-colors px-2 py-0.5 rounded-full
                ${active ? 'text-[#0A0A0A] dark:text-white' : ''}
                ${done ? 'text-emerald-500 dark:text-emerald-400 hover:text-emerald-600 dark:hover:text-emerald-300 cursor-pointer' : ''}
                ${!active && !done ? 'text-slate-400 dark:text-slate-600 cursor-default' : ''}
              `}
            >
              {done && <Check className="w-2.5 h-2.5" strokeWidth={3} />}
              <span>{label}</span>
              {i < STEPS.length - 1 && <span className="ml-1 text-slate-300 dark:text-white/10">·</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
